module.exports = __webpack_public_path__ + "static/media/RAEA-icon.182a3579.png";